
import React from "react";
import {Header} from "../header"


type Props = {
    //neccessary to load images into the new blank window (see header index.tsx)
    locationURL : string
}


/* Opens in a new window */
const ExplainDepositoryTypes : React.FC<Props> = (props ) => {


/*
    #page {
        width: 780px;
        margin: 0px auto;
        text-align: left;
        display: table;
    }
    
    #center {
        display: table-cell;
    }
    
    #clearstream_pic {
        width: 780px;
        height: 91px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }
    
    .depository-types th {
	text-align: left;
	font-weight: bold;
	padding-bottom: 7px;
    }


    .depository-types {
	font-size: 11px;
}
    
    
    
    */



return (

<div id="page" >
		<div id="center" >
			<Header location={props.locationURL}/>
			<div id="navigation"></div>
			<div id="content">
				<table className="depository-types">
					<tbody><tr>
						<th >Type</th>
						<th >Description</th>
					</tr>

					<tr>
						<td >CSK</td>
						<td >The entity appointed by the ICSDs to provide safekeeping
							for securities in NGN form.</td>
					</tr>

					<tr>
						<td >CSP</td>
						<td >The entity appointed by the ICSDs to provide asset
							servicing for securities in NGN form.</td>
					</tr>

					<tr>
						<td>COMMON</td>
						<td>Common Depositories are international depositories
							jointly appointed by Clearstream and Euroclear. They hold
							international securities in global form.</td>
					</tr>

					<tr>
						<td>DOMESTIC</td>
						<td>Domestic Depositories are specialised depositories
							holding domestic securities, which may be in various forms.</td>
					</tr>

					<tr>
						<td>EURO</td>
						<td>Euro Depositories are international specialised
							depositories. They hold international securities in either
							physical or book entry form.</td>
					</tr>

					<tr>
						<td>CTA</td>
						<td>CFF Transfer Agent.</td>
					</tr>

				</tbody></table>
			</div>
		</div>
		<div id="footer">
			<noscript>
			JAVASCRIP MUST BE ENABLED To view this page
			</noscript>
		</div>
	</div>
    )
}

export default ExplainDepositoryTypes